import { render } from "./ModalAssurancePayment.vue?vue&type=template&id=ea2b1dce&ts=true"
import script from "./ModalAssurancePayment.vue?vue&type=script&lang=ts"
export * from "./ModalAssurancePayment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__